"use strict";

import Swup from 'swup';
import SwupHeadPlugin from '@swup/head-plugin';
import SwupBodyClassPlugin from '@swup/body-class-plugin';


const swup = window.__swup || new Swup({
    animationSelector: '[class*="swup-transition-"]',
    plugins: [
        new SwupHeadPlugin(), 
        new SwupBodyClassPlugin()
    ]
});
window.__swup = swup;

const normalizeUrl = (value) => {
    if (!value) return '';
    try {
        const url = new URL(value, window.location.origin);
        const path = url.pathname.replace(/\/+$/, '/');
        return path + url.search;
    } catch (error) {
        return '';
    }
};

const resolveVisitUrls = (visit) => {
    let to = '';
    let from = '';

    if (visit && typeof visit === 'object') {
        if (visit.to && typeof visit.to.url === 'string') {
            to = visit.to.url;
        } else if (typeof visit.url === 'string') {
            to = visit.url;
        }

        if (visit.from && typeof visit.from.url === 'string') {
            from = visit.from.url;
        }
    }

    if (!from) {
        from = lastUrl;
    }

    return { to, from };
};

let lastUrl = window.location.href;
let forceScrollTop = false;

/**
 * Esegue la callback (cb) al DOM ready e ad ogni page:view di Swup.
 * Così i moduli non dipendono da Swup né istanziano nulla.
 */
function onReady(cb) {
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', cb, { once: true });
    } else {
        cb();
    }
    // Re-inizializza TUTTO ad ogni page:view di Swup
    swup.hooks.on('page:view', cb);
}

swup.hooks.on('visit:start', () => {
    const body   = document.body;
    const toggle = document.querySelector('#hamburgerToggle');
    const panel  = document.querySelector('#panelMenu');
    const overlay= document.querySelector('#panelOverlay');

    // chiudi menu e togli qualsiasi lock scroll
    body.classList.remove('menu-open', 'no-scroll');
    toggle?.classList.remove('is-active');
    panel?.classList.remove('in');
    overlay?.classList.remove('in');
});

swup.hooks.on('visit:start', (visit) => {
    const { to, from } = resolveVisitUrls(visit);
    const samePath = normalizeUrl(to) && normalizeUrl(to) === normalizeUrl(from);
    const hasHash = typeof to === 'string' && to.includes('#');
    forceScrollTop = samePath && !hasHash;
});

swup.hooks.on('page:view', () => {
    if (forceScrollTop) {
        if (window.__lenis && typeof window.__lenis.scrollTo === 'function') {
            window.__lenis.scrollTo(0, { immediate: true });
        } else {
            window.scrollTo(0, 0);
        }
    }
    forceScrollTop = false;
    lastUrl = window.location.href;
});


export { swup, onReady };
export default swup;
